<template>
  <div :class="classes.footerWrapper" v-if="terms">
    <div :class="classes.footer" v-html="terms" ref="termsRef" />
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { createUseStyles } from "@fresh8/vue-jss/src";
import * as language from "../lib/language";

import { useBrand } from "../hooks/useBrand";
import { useBetData } from "../hooks/useBetData";
import { useHandleAnalytics } from "../lib/analytics";
import { AnalyticEvents } from "../types/analytics";
import Boulder from "../images/Boulder.svg";
import { computed, onMounted, ref } from "vue";
import { injectOffer } from "../composition/offer";

const useStyles = createUseStyles({
  footerWrapper: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    boxSizing: "border-box",
    "@media screen and (min-width: 400px)": {
      paddingBottom: "11px",
      alignItems: "flex-end"
    }
  },
  footer: {
    fontSize: "11px",
    textAlign: "center",
    color: "#6C6D6F",
    "& a": {
      color: "rgb(0, 102, 204)",
      "&:after": {
        content: "''",
        backgroundImage: `url(${Boulder})`,
        backgroundRepeat: "no-repeat",
        width: "8px",
        height: "8px",
        marginLeft: "3px",
        display: "inline-block"
      }
    },
    "@media screen and (max-width: 400px)": {
      fontSize: "9px",
      lineHeight: 1
    }
  }
});

export default defineComponent({
  name: "Footer",
  components: {},
  setup() {
    const classesRef = useStyles();
    const { operator } = useBrand();
    const { links } = useBetData();
    const termsRef = ref(null);
    const $handleAnalytics = useHandleAnalytics();
    const { showOffer, offer } = injectOffer();

    const handleClick = () => {
      const statsEvent = AnalyticEvents.CLICKED_THROUGH;
      const statsDesc = "Terms and conditions";
      $handleAnalytics(statsEvent, statsDesc);
    };

    const languageCode = language.getLanugeCodeFromUrl();
    const terms = language.getValue(operator.value.key, languageCode, "terms");

    const displayTerms = computed(
      () => (showOffer.value && offer.value?.terms) || terms
    );

    onMounted(() => {
      const termsLink = termsRef.value.querySelector("a");
      if (termsLink) {
        termsLink.href = links.value?.provider;
        termsLink.addEventListener("click", handleClick, false);
      }
    });

    return {
      terms: displayTerms,
      termsRef,
      classes: classesRef.value
    };
  }
});
</script>

<style></style>
